import openQuestion from './openQuestion'
import applyJob from './applyJob'
import contactCandidate from './contactCandidate'
import onboardingQuestionnaire from './onboardingQuestionnaire'
import satisfactionQuestionnaire from './satisfactionQuestionnaire'
import portalQuestionnaire from './portalQuestionnaire'
import jobApplicationQuestionnaire from './jobApplicationQuestionnaire'

export default {
  openQuestion,
  applyJob,
  contactCandidate,
  onboardingQuestionnaire,
  satisfactionQuestionnaire,
  portalQuestionnaire,
  jobApplicationQuestionnaire
}
